export default "__VITE_ASSET__Currp_4f__"